import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useWallet } from '../hooks/useWallet';

/**
 * Legacy redirect: /agent/:agentId → /workspace/:portfolioId?tab=setup
 * Looks up the agent's primary portfolio assignment and redirects.
 * Falls back to /dashboard if no assignment found.
 */
export function AgentRedirect({ config }) {
  const { agentId } = useParams();
  const { jwtToken } = useWallet();
  const navigate = useNavigate();

  useEffect(() => {
    if (!jwtToken || !agentId) return;

    fetch(`${config.apiBaseUrl}/agents/${agentId}/portfolios`, {
      headers: { Authorization: `Bearer ${jwtToken}` },
    })
      .then(r => r.ok ? r.json() : [])
      .then(assignments => {
        const primary = assignments.find(a => a.role === 'primary' && a.is_active);
        if (primary) {
          navigate(`/workspace/${primary.portfolio_id}?tab=setup`, { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      })
      .catch(() => navigate('/dashboard', { replace: true }));
  }, [agentId, jwtToken, config.apiBaseUrl, navigate]);

  return (
    <div className="flex justify-center items-center min-h-screen">
      <svg className="animate-spin h-8 w-8 text-slate-400" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
      </svg>
    </div>
  );
}
